import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {AppConfig} from '../../../AppConfig'
import {FooterLocaleAndRegionSwitcher} from './FooterLocaleAndRegionSwitcher'

interface FooterNavigationForAppSectionsProps {
    // Раскладка задается снаружи: у самих колонок собственных отступов нет.
    className?: string
}

// Навигация по секциям сервиса для подвала.
export function FooterNavigationForAppSections(props: FooterNavigationForAppSectionsProps) {

    const {
        className = 'd-flex flex-row align-items-start gap-8',
    } = props

    return (
        <div className="flex-row-between align-items-start">
            <nav className={clsx('footer-nav', className)}>
                <div className="footer-nav-group">
                    <div className="footer-nav-group-heading">
                        {trans().common.footer.about_us}
                    </div>
                    <ul className="list-unstyled mt-3">
                        <li>
                            <Link to={appUrl().about}>
                                {trans().common.footer.about_project}
                            </Link>
                        </li>
                        {AppConfig.features.news !== false && (
                            <li>
                                <Link to={appUrl().news.list}>
                                    {trans().common.footer.news}
                                </Link>
                            </li>
                        )}
                        <li>
                            <Link to={appUrl().support.index}>
                                {trans().common.footer.questions_and_answers}
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="footer-nav-group">
                    <div className="footer-nav-group-heading">
                        {trans().common.footer.advertisements}
                    </div>
                    <ul className="list-unstyled mt-3">
                        <li>
                            <Link to={appUrl().ads.all}>
                                {trans().common.footer.promo_and_shops}
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
            <FooterLocaleAndRegionSwitcher />
        </div>
    )
}
